export const gtmEventName = {
    C_Global_Search: 'C_Global_Search',
    C_Quick_Link: 'C_Quick_Link',
    C_Consider_Events: 'C_Consider_Events',
    C_Featured_News: 'C_Featured_News',
    C_HomePage_Post: 'C_HomePage_Post',
    C_Community_Post: 'C_Community_Post',
    C_Post_Comment: 'C_Post_Comment',
    C_Inappropriate_Post: 'C_Inappropriate_Post',
    C_Post_Like: 'C_Post_Like',
    C_Hide_Post: 'C_Hide_Post',
    C_Delete_Post: 'C_Delete_Post',
    C_Chapter_Studio_Favorites_Click: 'C_Chapter_Studio_Favorites_Click',
    C_Post_Comments_Disabled: 'C_Post_Comments_Disabled',
    C_Event_Register_Button: 'C_Event_Register_Button',
    C_Directory_Event_Selected: 'C_Directory_Event_Selected',
    C_Around_Me_Feature_Event: 'C_Around_Me_Feature_Event',
    C_Around_Me_Location_Search_Text: 'C_Around_Me_Location_Search_Text',
    C_Around_Me_Location_Selected: 'C_Around_Me_Location_Selected',
    C_Around_Me_Current_Location: 'C_Around_Me_Current_Location',
    C_Around_Me_Establishment_Search_Text: 'C_Around_Me_Establishment_Search_Text',
    C_Around_Me_Establishment_Search_Suggestion_Selected: 'C_Around_Me_Establishment_Search_Suggestion_Selected',
    C_Around_Me_Establishment_Selected: 'C_Around_Me_Establishment_Selected',
    C_Community_Page_Viewed: 'C_Community_Page_Viewed',
    C_Community_Page_View_All_Members: 'C_Community_Page_View_All_Members',
    C_Community_Page_Member_Selected: 'C_Community_Page_Member_Selected',
    C_Admin_Confirm_Inappropriate_Post: 'C_Admin_Confirm_Inappropriate_Post',
    C_Admin_Confirm_Not_Inappropriate_Post: 'C_Admin_Confirm_Not_Inappropriate_Post',
    C_Network_Page_Selected_Network: 'C_Network_Page_Selected_Network',
    C_Network_Related_Community: 'C_Network_Related_Community',
    C_Connect_With_Suggested_Member: 'C_Connect_With_Suggested_Member',
    C_Connect_Ask_Concierge: 'C_Connect_Ask_Concierge',
    C_Connect_Call_Concierge: 'C_Connect_Call_Concierge',
    C_Connect_New_Group_Request: 'C_Connect_New_Group_Request',
    C_People_Search_Trigger: 'C_People_Search_Trigger',
    C_Event_Search_Trigger: 'C_Event_Search_Trigger',
    C_Community_Search_Trigger: 'C_Community_Search_Trigger',
    C_Content_Search_Trigger: 'C_Content_Search_Trigger',
    "C_Connect_Profile_Edit_Redirect_From_C+": 'C_Connect_Profile_Edit_Redirect_From_C+',
    C_Profile_Edit: 'C_Profile_Edit',
    C_Profile_Edit_Profile_Image: 'C_Profile_Edit_Profile_Image',
    C_Profile_Contact_Profile_Initiated: 'C_Profile_Contact_Profile_Initiated',
    C_Profile_Add_To_Connections: 'C_Profile_Add_To_Connections',
    C_Profile_Add_To_Follow: 'C_Profile_Add_To_Follow',
    C_Member_Directory_Profile_Viewed: 'C_Member_Directory_Profile_Viewed',
    C_Community_Directory_Selected_Community: 'C_Community_Directory_Selected_Community',
    C_Resource_Page_Ad_Buttons: 'C_Resource_Page_Ad_Buttons',
    C_Resource_Page_Resource_link: 'C_Resource_Page_Resource_link',
    C_Page_View: 'C_Page_View',
    C_Login_RecoverUN_ContactConcierge: 'C_Login_RecoverUN_ContactConcierge',
    C_Login_RecoverUN_ReturnToLogin: 'C_Login_RecoverUN_ReturnToLogin',
    C_Login_RecoverUN_Continue: 'C_Login_RecoverUN_Continue',
    C_Login_ContactUs_M2Mx: 'C_Login_ContactUs_M2Mx',
    C_Login_ContactUs_Email: 'C_Login_ContactUs_Email',
    C_Login_RecoverUN_ResendEmail: 'C_Login_RecoverUN_ResendEmail',
    C_Login_RecoverUN_Acknowledged_Page_View: 'Connect - Login | Recover Username Acknowledged',
    C_Landing_Page_Load_Time: 'C_Landing_Page_Load_Time',
    C_Auth_Without_Login_Page: 'C_Auth_Without_Login_Page',
    C_Auth_Successful: 'C_Auth_Successful',
    C_Auth_After_Login_Page: 'C_Auth_After_Login_Page',
};
